// cspell:disable -- review IDs are opaque base64-like strings from Google
import { GOOGLE_REVIEWS } from '../../reviews/google-reviews.generated';

export interface FunnelQuote {
  readonly text: string;
  readonly author: string;
}

// Curated excerpts from real Google reviews, one per funnel page. The
// author name is pulled from the generated reviews data (already
// cspell-disabled at the source), so adding new quotes here doesn't
// require touching the global wordlist.
function pickQuote(reviewId: string, excerpt: string): FunnelQuote {
  const review = GOOGLE_REVIEWS.find((r) => r.id === reviewId);
  if (!review) {
    throw new Error(`No GOOGLE_REVIEWS entry with id ${reviewId}`);
  }
  return { text: excerpt, author: review.author };
}

export const FUNNEL_QUOTES = {
  // Home page — outcome / "worth it" angle from a student who went
  // from self-taught hobbyist to playing professionally.
  home: pickQuote(
    'personal-jeremy-2023-07-08',
    'I went from just wanting to have fun in my room to dreaming and yearning to play professionally like Russ. Today that dream became a reality. I am now a professional bass player.',
  ),
  // What-I-teach page — teaching-method angle.
  whatITeach: pickQuote(
    'ChZDSUhNMG9nS0VJQ0FnTUNBbzZ6UVZnEAE',
    'Russ has experience and curriculum for all areas and skill levels. He customizes a learning plan for the student, based on their interests.',
  ),
} as const;
